import get from 'lodash/get';

type SortArrayObject = any[];
// Sort array of object by prop
export const sortArrayObjectByProp = (
  arrayObject: SortArrayObject,
  prop: keyof SortArrayObject,
) =>
  arrayObject.sort((a, b) => {
    const nameA = a[prop].toUpperCase(); // ignore upper and lowercase
    const nameB = b[prop].toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    // names must be equal
    return 0;
  });

export const roundUp = (number: number) => Math.ceil(number * 100) / 100;

export const roundUpCurrency = (number: number) => Math.ceil(number);

export const roundDownCurrency = (number: number) => Math.floor(number);
